// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1PMNa","title":"card_title__UW4Q8","inActive":"card_inActive__2t2HT"};